import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { ProjetService } from './../../../../core/services/projet-service/projet.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
export function dateRangeValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const startDate = group.get('start_date')?.value;
    const endDate = group.get('end_date')?.value;

    if (startDate && endDate && moment(startDate).isAfter(endDate)) {
      return {
        dateRangeError:
          'La date début ne doit pas être supérieure à la date fin.',
      };
    }

    return null;
  };
}
@Component({
  selector: 'app-details-project',
  templateUrl: './details-project.component.html',
  styleUrls: ['./details-project.component.css'],
})
export class DetailsProjectComponent {
  id = this.activatedRoute.snapshot.params['id'];
  disabledMode: boolean = true;
  detailproject: any;
  detailresponsable: any;
  listmembre: any;
  list: any;
  listmembrefinal: any = [];
  formprojet!: FormGroup;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  idclientConnected: any;
  membres: any = [];
  membresnv: any;
  sortAttr = '';
  responsable: any;
  type: any;
  loadSpinner: boolean = false;
  ischecked: boolean = false;
  isDisabled: boolean = true;
  pagination : boolean =false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private projetService: ProjetService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.getListmembre();
    this.getListnouveauxmembre();
    this.getListmembrebyproject();
    this.formprojet = this.formBuilder.group({
      id: ['', Validators.required],
      name: ['', Validators.required],
      membre_id: [null],
      membres: [[]],
      manager_id: ['', Validators.required],
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
      nbr_membres: ['', Validators.required],
      project_manager: ['', Validators.required],
      ID_project: ['', Validators.required],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
    },
    { validator: dateRangeValidator() }
  );
  }

  /* get project details */
  getprojectById() {
    this.spinner.show();
    this.projetService.getProjetById(this.id).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        console.log('detail projet', res);
        this.detailproject = res.data;
        this.detailresponsable =
          res?.responsable?.consultant_client_final?.candidate;
        console.log('detailresponsable', this.detailresponsable);
  
        this.formprojet.patchValue({
          id: this.detailproject.id,
          ID_project: this.detailproject.ID_project,
          manager_id: this.detailresponsable?.first_name,
          name: this.detailproject.name,
          nbr_membres: this.detailproject.nbr_membres,
          start_date: this.detailproject.start_date,
          end_date: this.detailproject.end_date,
        });
  
        console.log('responsable:', this.responsable);
        console.log('Form Values After Patch:', this.formprojet.value);
  
        let data = [];
  
        console.log('id res', res.responsable?.consultant_client_final_id);
        console.log('membre test', this.membres);
        for (const iterator of this.membres) {
          if (res.responsable &&
            res.responsable.consultant_client_final_id ==
            iterator.consultant_client_finals_id
          ) {
            data.push(iterator);
          }
        }
  
        console.log('data managerid', data);
        this.formprojet.get('manager_id')?.setValue(data[0]);
  
        let data1 = [];
        console.log("membresnv", this.membresnv);
        for (const iterator of this.membresnv) {
          for (const membre of res.membres) {
            if (membre.consultant_client_final_id == iterator.consultant_client_finals_id) {
              data1.push(iterator);
            }
          }
        }
        console.log("data1", data1);
  
        // Récupérer les IDs des membres existants
        const existingMemberIds = this.formprojet.get('membres')?.value || [];
  
        // Récupérer les nouveaux IDs des membres
        const newMembreIds = data1.map(item => item.consultant_client_finals_id);
  
        // Ajouter les nouveaux IDs seulement s'ils n'existent pas déjà
        const updatedMemberIds = [...existingMemberIds, ...newMembreIds].filter((value, index, self) => {
          return self.indexOf(value) === index;
        });
  
        // Définir la nouvelle liste des membres dans le formulaire
        this.formprojet.get('membres')?.setValue(updatedMemberIds);
        // if(res.membres.length!==0)
        //   {
        //     this.formprojet.get('membres')?.setValue(updatedMemberIds);
  
        //   }
        //   else{
        //     this.formprojet.get('membres')?.setValue("");
  
        //   }
        console.log('membre test 2', this.membres);
        console.log('this.updateform', this.formprojet.value);
      },
      error: (error) => {
        console.log('error detail', error);
      },
    });
  }
  
  getresponsable(selectedManagerId: any) {
    let data = [];
    
    // Trouver le membre correspondant au manager sélectionné
    for (const iterator of this.membres) {
      if (selectedManagerId.id == iterator.id) {
        data.push(iterator);
      }
    }
  
    console.log("data", data);
  
    // Récupérer les IDs des membres existants
    const existingMemberIds = this.formprojet.get('membres')?.value || [];
  
    // Récupérer l'ID du nouveau responsable
    const newMembreIds = data.map(item => item.consultant_client_finals_id);
  
    // Ajouter le nouvel ID seulement s'il n'existe pas déjà
    let updatedMemberIds = [...existingMemberIds, ...newMembreIds].filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
  
    // Vérifier si le responsable a été supprimé (selectedManagerId est null ou vide)
    if (!selectedManagerId || !selectedManagerId.id) {
      // Retirer l'ancien responsable des membres
      const responsableId = this.formprojet.get('manager_id')?.value?.consultant_client_finals_id;
      if (responsableId) {
        updatedMemberIds = updatedMemberIds.filter(id => id !== responsableId);
      }
    }
  
    // Définir la nouvelle liste des membres dans le formulaire
    this.formprojet.get('membres')?.setValue(updatedMemberIds);
    
  
    console.log('this updateform : ', this.formprojet.value);
  }

  removeResponsable(membres: any[]) {
    console.log("Membres après changement:", membres);

    // Récupérer l'ID du responsable actuel
    const responsableId = this.formprojet.get('manager_id')?.value?.consultant_client_finals_id;

    // Vérifier si le responsable actuel est dans la liste des membres
    const isResponsablePresent = membres.some((membre: any) => membre.consultant_client_finals_id === responsableId);

    if (!isResponsablePresent && responsableId) {
        // Supprimer le responsable actuel
        this.formprojet.get('manager_id')?.setValue(null);

        // Mettre à jour la liste des membres en supprimant le responsable
        const existingMemberIds = this.formprojet.get('membres')?.value || [];
        const updatedMemberIds = existingMemberIds.filter((id: any) => id !== responsableId);
        this.formprojet.get('membres')?.setValue(updatedMemberIds);

        console.log('Responsable supprimé, formulaire mis à jour:', this.formprojet.value);
    } else {
        console.log('Le responsable est encore dans la liste des membres ou aucun responsable actuel.');
    }
}



  onCheckboxChange(event: any) {
    console.log(event.target.checked);
    if (event.target.checked) {
      this.ischecked = true;
    } else {
      this.ischecked = false;
    }
    console.log(this.ischecked);
  }

  sortData() {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.getListmembrebyproject();
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){          this.pagination = true
          this.getListmembrebyproject();
        }
    }
  }
  getListmembrebyproject() {
    let dataPyload = {
      id: this.id,
      per_page: this.itemsPerPage,
      page: this.currentPage,
      sort: this.currentSortDirection,
    };
    console.log('data per page', dataPyload.per_page);
    console.log('data page', dataPyload.page);

    this.projetService.getmembrebyproject(dataPyload).subscribe({
      next: (response: any) => {
        console.log('response membre', response);
        if (response.data && response.data.data) {
          this.listmembrefinal = response.data.data;
          this.totalItems = response.data.total;

          console.log(' listmembrefinal', this.listmembrefinal);
        }
      },
      error: (error) => {
        console.error('Error fetching membre: ', error);
      },
    });
  }
  getListmembre() {
    this.spinner.show();
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');

    this.projetService.getlistRoles(this.idclientConnected).subscribe({
      next: (response) => {
        console.log('response', response);
        if (response.data) {
          this.membres = response.data;
          this.listresponsablesWithDisplayName();
          console.log('list membre', this.membres);
          this.getprojectById();
        }
      },
      error: (error) => {
        console.error('Error fetching membre: ', error);
      },
    });
  }

  listresponsablesWithDisplayName() {
    this.membres.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
    console.log('membres2', this.membres);
  }
  listnvmembresWithDisplayName() {
    this.membresnv.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }
  getListnouveauxmembre() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');

    this.projetService
      .getnouveaumembre(this.idclientConnected, this.id)
      .subscribe({
        next: (response) => {
          console.log('liste nouveau menbre ', response);
          if (response) {
            this.spinner.hide();
            this.membresnv = response;
            console.log('list membrenouveau', this.membresnv);
            this.listnvmembresWithDisplayName();
          }
        },
        error: (error) => {
          console.error('Error fetching membre: ', error);
        },
      });
  }
  ///////////////////////////////////////////////////////////////////////////////////////////

  deletemembre(m: any) {
    Swal.fire({
      title: 'Vous êtes sûr de supprimer le membre sélectionné ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Annuler', // Modifier le texte du bouton Cancel ici
    }).then((result) => {
      if (result.isConfirmed) {
        this.projetService
          .deletemembre(m.projectCandidate_id)
          .subscribe((res: any) => {
            console.log('response', res);
            this.toastr.success('Le Membre a été supprimé avec succès.', '', {
              timeOut: 3000,
            });
            setTimeout(() => {
              this.getListmembrebyproject();
              this.getprojectById()
              this.getListnouveauxmembre();
              this.getListmembre();
              window.location.reload()
              ;
            }, 3000);
          });
      }
    });
  }

  updateprojet() {
    const membre = this.formprojet.get('manager_id')?.value;
    console.log('membre', membre);

    let data: any;
    console.log(
      'this.formprojet.value.manager_id',
      this.formprojet.value.manager_id
    );
    const managerId =
      this.formprojet?.value?.manager_id?.consultant_client_finals_id;
    console.log('manager id', managerId);
    if (this.formprojet.value.membres.length != 0) {
      data = {
        name: this.formprojet.value.name,
        manager_id: managerId,
        membres: this.formprojet.value.membres.map(String),
        end_date: this.formprojet.value.end_date,
        start_date: this.formprojet.value.start_date,
      };
      console.log('data membres', data);
    } else if (this.formprojet.value.membre_id) {
      data = {
        name: this.formprojet.value.name,
        manager_id: managerId,
        membre_id: this.formprojet.value.membre_id,
        end_date: this.formprojet.value.end_date,
        start_date: this.formprojet.value.start_date,
      };
      console.log('data membre_id', data);
    } else {
      data = {
        name: this.formprojet.value.name,
        manager_id: managerId,
        end_date: this.formprojet.value.end_date,
        start_date: this.formprojet.value.start_date,
      };
    }
    console.log('data', data);

    this.projetService.updateprojet(this.id, data).subscribe({
      next: (res: any) => {
        console.log('update job offer', res);
        this.toastr.success('Le projet a été modifié avec succès');
        this.getprojectById();
        this.getListmembre();
        this.getListmembrebyproject();
        // this.navigateToProfile();
      },
      error: (error) => {
        console.error('Error fetching add projet: ', error);
        if (
          error.status === 400 ||
          (error.data && error.data.name) ||
          error.data.name[0] === 'The name has already been taken.'
        ) {
          this.toastr.info('Le nom du projet existe déjà.');
        } else {
          this.toastr.error(
            "Une erreur s'est produite lors de la création du projet."
          );
        }
      },
    });
  }
  navigateToProfile() {
    this.router.navigate(['/projets/liste']);
  }

  getFullName(member: any): string {
    return `${member.first_name} ${member.last_name}`;
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  enableDisableMode() {
    this.disabledMode = !this.disabledMode;
  }

  enabledetailproject() {
    // Inversez l'état de l'entrée.
    this.isDisabled = !this.isDisabled;
  }
}
